import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, Spin } from 'antd';
import styled, { keyframes } from 'styled-components';
const fadeIn = keyframes `
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;
const StyledModal = styled(Modal) `
  .ant-modal-content {
    border-radius: 16px;
    padding: 40px 24px;
    background-color: #ffffff;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
    animation: ${fadeIn} 0.3s ease-out;
    text-align: center;
  }

  .ant-modal-body {
    padding: 0;
  }
`;
const SpinnerWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Message = styled.p `
  margin-top: 16px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;
const ProgressModal = ({ open }) => {
    return (_jsx(StyledModal, { open: open, footer: null, maskClosable: false, keyboard: false, closable: false, centered: true, children: _jsxs(SpinnerWrapper, { children: [_jsx(Spin, { size: "large" }), _jsx(Message, { children: "Saving route in progress" })] }) }));
};
export default ProgressModal;
